export default {
  uri: undefined,
  connecting: false,
  error: '',
};
